<template>
  <v-card flat class="conteneurLead" id="conteneurLead">
      <v-card-title class="primary white--text"  style="height: 52px;  padding: 0px;">
        <v-btn icon @click="cancelDialog()"><v-icon class="white--text">close</v-icon></v-btn>
        <div class="title tf_title_dialog">{{ $t('Suppression de messagee') }}</div>
        <v-spacer></v-spacer>
        <v-btn
            :loading="loading"
            :disabled="loading"
            v-if="$vuetify.breakpoint.smAndDown"
            flat
            @click.native="submitSuppExempleIntent"
            class="white--text"
        >{{ $t('delete') }}</v-btn>
      </v-card-title>
      <v-card-text>
          <span class='body-1 '>Voulez-vous supprimer ce message : </span><br>
          <span class='body-2 font-weight-bold'>{{exemple}}</span>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn flat @click.native="cancelDialog()">{{ $t('cancel') }}</v-btn>
        <v-btn
          :loading="loading"
          :disabled="loading"
          color="primary"
          flat
          @click.native="submitSuppExempleIntent"
        >{{ $t('delete') }}</v-btn>
      </v-card-actions>
  </v-card>
</template>

<script>
import _ from 'lodash'
export default {
  props: {
    modeExpert: {
      type: Boolean,
      default: false
    },
    botWorkspace: {
      type: String,
      default: ''
    },
    exemple: {
      type: String,
      default: ''
    },
    listeExemples: {
      type: Array,
      default: () => ({})
    },
    faqDialog: {
      type: Object,
      default: () => ({})
    }
  },
  data () {
    return {
      newExemple: '',
      loading: false
    }
  },
  mounted () {
    this.loading = false
  },
  updated () {},
  computed: {},
  methods: {
    cancelDialog () {
      this.$emit('closeDialog')
      this.loading = false
    },
    submitSuppExempleIntent () {
      this.loading = true
      console.log('faqDialog', this.faqDialog)
      // this.$emit('suppEx', this.newExemple)
      this.suppEx()
    },
    suppEx () {
      console.log('suppEx', this.exemple)
      console.log('deleteSampleIntent : faqDialog', this.faqDialog)
      // cefface l'exemple de watson
      // Données modifiées et à renvoyer
      // il faut retirer le # avant l'enregistrement
      let intentName = this.faqDialog.intend.substring(1, this.faqDialog.intend.length)
      let oldExemple = encodeURIComponent(this.exemple)
      let dataToPost = new window.FormData()
      dataToPost.append('intent', intentName)
      dataToPost.append('oldExemple', oldExemple)
      dataToPost.append('botWorkspace', this.botWorkspace)
      this.axios.post('https://public.targetfirst.com/public/ibm/delete_example_intent.php', dataToPost, {headers: {'Content-Type': 'application/x-www-form-urlencoded'}})
      // this.axios.post('put/intent.php', dataToPost, {headers: {'Content-Type': 'application/x-www-form-urlencoded'}})
      .then(response => {
        console.log('nouvel exemple', response)
        this.$emit('closeDialog')
        this.suppExBDD()
        // this.$store.dispatch('_Notifier/NEW_NOTIF', { message: this.$t('le message a été supprimé'), context: 'success' })
        // this.showDialogSupExempleIntent = false
      })
      .catch(_ => {
        // console.log('erreur response', response)
        this.$store.dispatch('_Notifier/NEW_NOTIF', { message: this.$t('erreur de connexion au chatbot'), context: 'error' })
        this.showDialogSupExempleIntent = false
      })
    },
    // il faut supprimer l'ewemple en base
    suppExBDD () {
      console.log('suppExBDD : exemple', this.exemple)
      console.log('suppExBDD : faqDialog', this.faqDialog)
      let intentName = this.faqDialog.intend.substring(1, this.faqDialog.intend.length)
      let dataToPost = new window.FormData()
      dataToPost.append('intent', intentName)
      dataToPost.append('botWorkspace', this.botWorkspace)
      dataToPost.append('exemple', this.exemple)
      this.axios.post('put/delete_exemple_intent.php', dataToPost, {headers: {'Content-Type': 'application/x-www-form-urlencoded'}})
      .then(response => {
        console.log('suppExBDD', response)
        this.MAJIntentsStore(this.exemple, intentName)
        this.loading = false
        this.$store.dispatch('_Notifier/NEW_NOTIF', { message: this.$t('exemple de message supprimé'), context: 'success' })
        // this.showDialogAddQuestionIntent = false
      })
      .catch(_ => {
        // console.log('erreur response', response)
        this.$store.dispatch('_Notifier/NEW_NOTIF', { message: this.$t('erreur de connexion à la base de données'), context: 'error' })
      })
    },
    // il faut supprimer l'exemple de l'intention du store
    MAJIntentsStore (exemple, intentID) {
      console.log('MAJIntentsStore', exemple)
      let listIntents = _.cloneDeep(this.$store.state._Sites.intents)
      let index = _.findIndex(listIntents, function (o) { return o.code === intentID })
      if (index !== -1) {
        // console.log('listIntents[index].ex', listIntents[index].ex)
        let indexSupp = listIntents[index].ex.findIndex(ex => ex === exemple)
        if (indexSupp !== -1) {
          console.log('trouvé en ', indexSupp)
          // supprime l'exemple'
          listIntents[index].ex.splice(indexSupp, 1)
          // console.log('listIntents[index].ex', listIntents[index].ex)
          // mise à jour du store
          this.$store.commit('_Sites/SET_INTENTS', listIntents)
          // mise en jour lde la liste en temps réel
          this.$emit('removeExemple', listIntents[index].ex)
        }
      }
    }
  },
  watch: {},
  filters: {}
}
</script>

<style scoped>
  .tf_title_dialog {
    text-overflow: ellipsis;
    width: calc(100% - 180px);
    overflow: hidden;
    white-space: nowrap;
  }
</style>



// WEBPACK FOOTER //
// src/components/watcheezy/WzDeleteExempleIntent.vue